// useDropdownData.js
import { useEffect, useMemo, useState } from "react";

export function useDropdownData(fetchFunction, fetchArgs = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // stable key from args values
  const argsKey = useMemo(() => JSON.stringify(fetchArgs ?? []), [fetchArgs]);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchFunction(...(fetchArgs ?? []));
        if (cancelled) return;

        if (Array.isArray(result)) {
          setData(result);
        } else {
          setData([]);
          setError("No data found");
        }
      } catch (err) {
        if (cancelled) return;
        console.error(err);
        setData([]);
        setError("Fetch failed");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    if ((fetchArgs ?? []).every((arg) => Boolean(arg))) {
      fetchData();
    } else {
      setData([]);
    }

    return () => {
      cancelled = true;
    };
  }, [fetchFunction, argsKey]);

  return { data, loading, error };
}
